<template>
    <div>
        <div class="form-row">
            <div class="form-group col-md-12">
                <label :for="names.address">Land (*)</label>
                <select class="form-control" :name="names.country" :id="names.country" v-model="currentCountry" @change="updateAddress">
                    <option v-for="(country, iso) in countries" :key="country" :value="iso" :selected="currentCountry == iso">{{ country }}</option>
                </select>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-4">
                <label :for="names.postal">Postcode (*)</label>
                <input class="form-control" :name="names.postal" v-model="currentPostal"
                    @keyup="updateAddress" :id="names.postal"/>
            </div>
            <div class="form-group col-md-4">
                <label :for="names.house_number">Huisnummer (*)</label>
                <input class="form-control" :name="names.house_number" v-model="currentHouseNumber"
                    @keyup="updateAddress" :id="names.house_number">
            </div>
            <div class="form-group col-md-4">
                <label :for="names.house_number_addition">Toevoeging</label>
                <input class="form-control" :name="names.house_number_addition" v-model="currentHouseNumberAddition" :id="names.house_number_addition">
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-6">
                <label for="street">Straatnaam (*)</label>
                <input type="text" name="street" class="form-control" autocomplete="off" v-model="currentStreet" />
            </div>
            <div class="form-group col-md-6">
                <label :for="names.city">Plaats (*)</label>
                <input type="text" class="form-control" autocomplete="off" :name="names.city" :id="names.city" :value="currentCity" />
            </div>
        </div>

        <input type="hidden" :name="names.street" :value="currentStreet"/>

    </div>
</template>

<script>
import {debounce} from 'lodash';

const CancelToken = require('axios').CancelToken;
let cancelSource;

export default {
    name: "AddressAutoComplete",
    props: {
        postal: {
            required: false,
            type: String,
            default: '',
        },
        houseNumber: {
            required: false,
            type: String,
            default: '',
        },
        houseNumberAddition: {
            required: false,
            type: String,
            default: '',
        },
        street: {
            required: false,
            type: String,
            default: '',
        },
        city: {
            required: false,
            type: String,
            default: '',
        },
        country: {
            required: false,
            type: String,
        },
        countries: {
            required: true,
            type: Object
        },
        names: {
            required: false,
            type: Object,
            default() {
                return {
                    postal: 'postal',
                    house_number: 'house_number',
                    house_number_addition: 'house_number_addition',
                    street: 'street',
                    city: 'city',
                    country: 'country'
                }
            }
        }
    },
    data() {
        return {
            found: true,
            currentPostal: '',
            currentHouseNumber: '',
            currentHouseNumberAddition: '',
            currentStreet: '',
            currentCity: '',
            currentCountry: '',
            skipPostalCheckCountries: ['BE'],
        }
    },
    methods: {
        updateAddress: debounce(function () {
            cancelSource && cancelSource.cancel('Request cancelled');
            cancelSource = CancelToken.source();

            if(this.skipPostalCheckCountries.includes(this.currentCountry)) {
                this.found = false;

                return;
            }

            if (this.currentPostal.length <= 5) return;

            axios.post(`/api/site/lookup-address/`, {
                postal: this.currentPostal,
                house_number: this.currentHouseNumber
            }, {
                cancelToken: cancelSource.token
            })
                // Change address = street
                .then(response => {
                    let data = response.data;
                    this.currentStreet = data.street.trim();
                    this.currentCity = data.city;
                    this.found = !!data.found;
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        // We cancelled this request...
                    } else {
                      this.found = false;
                        // handle error
                    }
                }).finally(() => {
                this.isLoading = false;
            });
        }, 300),

        label(text) {
            return text;
        }


    },
    mounted() {
        this.currentPostal = this.postal;
        this.currentHouseNumber = this.houseNumber;
        this.currentHouseNumberAddition = this.houseNumberAddition;
        this.currentStreet = this.street;
        this.currentCity = this.city;
        this.currentCountry = this.country;
        if(this.skipPostalCheckCountries.includes(this.currentCountry)) {
            this.found = false;
        }
    }
}
</script>

<style scoped>

</style>
